module.exports = __webpack_public_path__ + "static/media/2020-image.524c4f50.png";